import React, { useState, useEffect, useRef } from 'react';
import connect from "react-redux/es/connect/connect";
import { setCurrentNavPage } from "actions";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import _ from "i18n";
import PeriodFilter from "../../components/Filters/EventStats/PeriodFilter";
import BelgiumCityMap from '../../components/Admin/EventStats/EventRegistrantLinechart/BelgiumMap';
import { getAccumulateStats, getCAByFormat, getCotisationMonths, getMembershipAssociative, getNbrCotisantByFormat, getNbrCotisants, getTypeFormats } from '../../actions/thunks/statistics';
import { Checkbox, Col, DatePicker, Icon, Progress, Row } from 'antd';
import ContributionChart from '../../components/Admin/EventStats/EventRegistrantLinechart/ContributionChart';
import { CommonLoader } from '../../components/common/CommonLoader';
import CotisantFilters from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantFilters';
import CotisantStats from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStats';
import { formatCotisantData, newSeasonFilterStyle } from '../../services/utils';
import CotisantStatsChartLine from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsChartLine';
import CotisantStatsCompare from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsCompare';
import moment from 'moment';
import CotisantStatsChartLineCompare from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsChartLineCompare';
import CotisationFilterTypeCotisation from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisationFilterTypeCotisation';
import ReactSelect, { components } from "react-select";
import t from "i18n";
import { deleteCacheForCotisationStats, getCacheOldestEntryPeriodForCotisationStats } from '../../actions/thunks/eventStats';
import MonthFilterContribution from '../../components/Filters/EventStats/CompareStats/MonthFilterContribution';
import PeriodFilterCotisation from '../../components/Filters/EventStats/PeriodFilterCotisation';
import { set } from 'lodash';


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};
const ContributionStatisticsPage = ({
  eventStatsFilter,
  lng,
  setCurrentNavPage,
  getNbrCotisants,
  getTypeFormats,
  getNbrCotisantByFormat,
  getCAByFormat,
  getCotisationMonths,
  getMembershipAssociative,
  getAccumulateStats,
  deleteCacheForCotisationStats,
  getCacheOldestEntryPeriodForCotisationStats,
}) => {
  const [period, setPeriod] = useState(new Date().getFullYear());
  const [cityPercentageData, setCityPercentageData] = useState({});
  const [topFiveCityPercentageData, setTopFiveCityPercentageData] = useState([]);
  const [typeCotisants, setTypeCotisants] = useState({});
  const [nbrInscriptionFetch, setNbrInscriptionFetch] = useState(false);
  const [typeCotisantsFetch, setTypeCotisantsFetch] = useState(false);
  const [activeTab, setActiveTab] = useState("cotisation");
  const [activeTabTypeCotisation, setActiveTabTypeCotisation] = useState("cotisation");
  const [selectedFrequency, setSelectedFrequency] = useState("MONTHLY");
  const [nbrCotisantByFormat, setNbrCotisantByFormat] = useState({});
  const [nbrCotisantByFormatPrevYear, setNbrCotisantByFormatPrevYear] = useState({});
  const [nbrCotisantByFormatFetch, setNbrCotisantByFormatFetch] = useState(false);
  const [caCotisantByFormat, setCaCotisantByFormat] = useState({});
  const [caCotisantByFormatPrevYear, setCaCotisantByFormatPrevYear] = useState({});
  const [caCotisantByFormatFetch, setCaCotisantByFormatFetch] = useState(false);
  const [nbrCotisantByFormatCompare, setNbrCotisantByFormatCompare] = useState({});
  const [nbrCotisantByFormatCompareFetch, setNbrCotisantByFormatCompareFetch] = useState(false);
  const [caCotisantByFormatCompare, setCaCotisantByFormatCompare] = useState({});
  const [caCotisantByFormatCompareFetch, setCaCotisantByFormatCompareFetch] = useState(false);
  const [showCompareStats, setShowCompareStats] = useState(false);
  const [monthsForDaily, setMonthsForDaily] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [associativeMembership, setAssociativeMembership] = useState(0);
  const [fetchingMembershipAssociative, setFetchingMembershipAssociative] = useState(false);
  const [membershipAssociativeComapre, setMembershipAssociativeComapre] = useState(0);
  const [membershipAssociativeComapreFetch, setMembershipAssociativeComapreFetch] = useState(false);
  const [showAccumulateStats, setShowAccumulateStats] = useState(false);
  const [nbrCotisantByFormatAccumulate, setNbrCotisantByFormatAccumulate] = useState({});
  const [nbrCotisantByFormatAccumulateFetch, setNbrCotisantByFormatAccumulateFetch] = useState(false);
  const [caCotisantByFormatAccumulate, setCaCotisantByFormatAccumulate] = useState({});
  const [caCotisantByFormatAccumulateFetch, setCaCotisantByFormatAccumulateFetch] = useState(false);
  const [nbrCotisantByFormatAccumulateCompare, setNbrCotisantByFormatAccumulateCompare] = useState({});
  const [nbrCotisantByFormatAccumulateCompareFetch, setNbrCotisantByFormatAccumulateCompareFetch] = useState(false);
  const [caCotisantByFormatAccumulateCompare, setCaCotisantByFormatAccumulateCompare] = useState({});
  const [caCotisantByFormatAccumulateCompareFetch, setCaCotisantByFormatAccumulateCompareFetch] = useState(false);
  const [visibleKeys, setVisibleKeys] = useState(['Statutaire', 'Fiduciaire']);
  const [showCompareAppTypeStats, setShowCompareAppTypeStats] = useState(false);
  const [showCompareAppTypeStatsArray, setShowCompareAppTypeStatsArray] = useState([]);
  const [lineNameForStats, setLineNameForStats] = useState('');
  const [compareAll, setCompareAll] = useState(false);
  const [startMonth, setStartMonth] = useState('2024-10');
  const [endMonth, setEndMonth] = useState('2025-12');
  const [firstVariant, setFirstVariant] = useState(75);
  const [secondVariant, setSecondVariant] = useState(50);
  const [thirdVariant, setThirdVariant] = useState(25);

  const prevPeriodRef = useRef(period);
  const prevSelectedFrequencyRef = useRef(selectedFrequency);
  const prevSelectedMonthRef = useRef(selectedMonth);
  const prevShowCompareStatsRef = useRef(showCompareStats);

  const getValuesFromLocalStorage = () => {
    const startMonthLocal = localStorage.getItem('startMonthCotisationStats');
    if (startMonthLocal) {
      setStartMonth(startMonthLocal);
    }
    const endMonthLocal = localStorage.getItem('endMonthCotisationStats');
    if (endMonthLocal) {
      setEndMonth(endMonthLocal);
    }
  };

  useEffect(() => {
    setStartMonth(`${period - 1}-10`);
    setEndMonth(`${period}-12`);
    getValuesFromLocalStorage();

    setCurrentNavPage("CONTRIBUTION");
    setNbrInscriptionFetch(true);
    setTypeCotisantsFetch(true);
    setNbrCotisantByFormatFetch(true);
    setCaCotisantByFormatFetch(true);
    setFetchingMembershipAssociative(true);

    getNbrCotisants([period]).then((res) => {
      const cityPercentageData = Object.values(res.value.data.data).reduce((acc, item) => {
        const regionKey = item.region === "Bruxelles-Capitale - Brussel-Hoofdstad"
          ? "Bruxelles"
          : item.region;

        acc[regionKey] = [item.nbrInscription, item.ca];
        return acc;
      }, {});

      const sortedData = Object.values(res.value.data.data).sort((a, b) => b.ca - a.ca);
      const topFiveCityPercentageData = sortedData.slice(0, 5);

      setCityPercentageData(cityPercentageData);
      setTopFiveCityPercentageData(topFiveCityPercentageData);
      setNbrInscriptionFetch(false);
    });

    getTypeFormats([period]).then((res) => {
      setTypeCotisants(res.value.data.data);
      setTypeCotisantsFetch(false);
    });

    getNbrCotisantByFormat([period], selectedFrequency).then((res) => {
      setNbrCotisantByFormat(res.value.data.data);
      setNbrCotisantByFormatFetch(false);
      getCAByFormat([period], selectedFrequency).then((res) => {
        setCaCotisantByFormat(res.value.data.data);
        setCaCotisantByFormatFetch(false);
      });
    });



    getCotisationMonths([period]).then((res) => {
      // get the current year and month like 2023-10
      const currentYear = moment().format('YYYY');
      const currentMonth = moment().format('MM');
      const currentYearMonth = `${currentYear}-${currentMonth}`;
      setMonthsForDaily(res.value.data.data);
      setSelectedMonth(currentYearMonth);
    });

    getMembershipAssociative([period], selectedFrequency).then((res) => {
      setAssociativeMembership(res.value.data.data.sum);
      setFetchingMembershipAssociative(false);
    });

    const initialShowCompareAppTypeStatsArray = [];
    initialShowCompareAppTypeStatsArray['Statutaire'] = false;
    initialShowCompareAppTypeStatsArray['Fiduciaire'] = false;
    setShowCompareAppTypeStatsArray(initialShowCompareAppTypeStatsArray);

    // if(this.props.eventStatsFilter.year.length == 1 && this.state.selectedFrequency == 'MONTHLY') {
    //   this.props.getNbrCotisantByFormat([this.props.eventStatsFilter.year[0] - 1], this.props.eventStatsFilter.year.length > 1 ? "YEARLY" : this.state.selectedFrequency).then((res) => {
    //     this.setState({nbrCotisantByFormatCompare: res.value.data.data, nbrCotisantByFormatCompareFetch: false});
    //   });
    // }
  }, []);

  useEffect(() => {
    if (prevPeriodRef.current === period) return;
    prevPeriodRef.current = period;

    const yearsFrom2024 = Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (v, k) => k + 2024);

    setNbrInscriptionFetch(true);
    setTypeCotisantsFetch(true);
    setNbrCotisantByFormatFetch(true);
    setFetchingMembershipAssociative(true);
    setShowCompareAppTypeStats(false);
    setVisibleKeys(['Statutaire', 'Fiduciaire']);
    setShowAccumulateStats(false);
    setCompareAll(false);
    setSelectedFrequency('MONTHLY');
    setSelectedMonth('');
    setStartMonth(`${period - 1}-10`);
    setEndMonth(`${period}-12`);

    localStorage.setItem('startMonthCotisationStats', `${period - 1}-10`);
    localStorage.setItem('endMonthCotisationStats', `${period}-12`);

    getNbrCotisants([period]).then((res) => {
      const cityPercentageData = Object.values(res.value.data.data).reduce((acc, item) => {
        const regionKey = item.region === "Bruxelles-Capitale - Brussel-Hoofdstad"
          ? "Bruxelles"
          : item.region;

        acc[regionKey] = [item.nbrInscription, item.ca];
        return acc;
      }, {});

      const sortedData = Object.values(res.value.data.data).sort((a, b) => b.ca - a.ca);
      const topFiveCityPercentageData = sortedData.slice(0, 5);

      setCityPercentageData(cityPercentageData);
      setTopFiveCityPercentageData(topFiveCityPercentageData);
      setNbrInscriptionFetch(false);
    });

    getTypeFormats([period]).then((res) => {
      setTypeCotisants(res.value.data.data);
      setTypeCotisantsFetch(false);
    });

    getNbrCotisantByFormat([period], "MONTHLY").then((res) => {
      setNbrCotisantByFormat(res.value.data.data);
      setNbrCotisantByFormatFetch(false);
      getCAByFormat([period], "MONTHLY").then((res) => {
        setCaCotisantByFormat(res.value.data.data);
        setCaCotisantByFormatFetch(false);
      });
    });



    getMembershipAssociative([period], "MONTHLY").then((res) => {
      setAssociativeMembership(res.value.data.data.sum);
      setFetchingMembershipAssociative(false);
    });

    getCotisationMonths([period]).then((res) => {
      // get the current year and month like 2023-10
      const currentYear = moment().format('YYYY');
      const currentMonth = moment().format('MM');
      const currentYearMonth = `${currentYear}-${currentMonth}`;

      setMonthsForDaily(res.value.data.data);
      setSelectedMonth(period === currentYear ? currentYearMonth : res.value.data.data[0]);

    });
  }, [period]);

  // componentDidUpdate — selectedFrequency
  useEffect(() => {
    if (prevSelectedFrequencyRef.current === selectedFrequency) return;
    prevSelectedFrequencyRef.current = selectedFrequency;

    setNbrCotisantByFormatFetch(true);
    setCaCotisantByFormatFetch(true);
    setTypeCotisantsFetch(true);
    setShowCompareAppTypeStats(false);
    setVisibleKeys(['Statutaire', 'Fiduciaire']);
    setShowAccumulateStats(false);
    setCompareAll(false);

    getTypeFormats([period]).then((res) => {
      setTypeCotisants(res.value.data.data);
      setTypeCotisantsFetch(false);
    });

    if (selectedFrequency !== "DAILY") {
      getNbrCotisantByFormat([period], selectedFrequency).then((res) => {
        setNbrCotisantByFormat(res.value.data.data);
        setNbrCotisantByFormatFetch(false);
        getCAByFormat([period], selectedFrequency).then((res) => {
          setCaCotisantByFormat(res.value.data.data);
          setCaCotisantByFormatFetch(false);
        });
      });



      getMembershipAssociative([period], selectedFrequency).then((res) => {
        setAssociativeMembership(res.value.data.data.sum);
        setFetchingMembershipAssociative(false);
      });
    }

    if (selectedFrequency === "DAILY") {
      setNbrCotisantByFormatAccumulateFetch(true);
      setCaCotisantByFormatAccumulateFetch(true);
      const [year, month] = selectedMonth.split("-");

      getNbrCotisantByFormat([period], "DAILY", selectedMonth).then((res) => {
        setNbrCotisantByFormat(res.value.data.data);
        getNbrCotisantByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
          setNbrCotisantByFormatPrevYear(res.value.data.data);
          setNbrCotisantByFormatFetch(false);
        });

        getCAByFormat([period], "DAILY", selectedMonth).then((res) => {
          setCaCotisantByFormat(res.value.data.data);
          getCAByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
            setCaCotisantByFormatPrevYear(res.value.data.data);
            setCaCotisantByFormatFetch(false);
          });
        });
      });

      getMembershipAssociative([period], "DAILY", selectedMonth).then((res) => {
        setAssociativeMembership(res.value.data.data.sum);
        setFetchingMembershipAssociative(false);
      });

      getAccumulateStats([period], selectedFrequency, selectedMonth, 'NBR_COTISATIONS').then((res) => {
        setNbrCotisantByFormatAccumulate(res.value.data.data);
        setNbrCotisantByFormatAccumulateFetch(false);
      });

      getAccumulateStats([period], selectedFrequency, selectedMonth, 'CA').then((res) => {
        setCaCotisantByFormatAccumulate(res.value.data.data);
        setCaCotisantByFormatAccumulateFetch(false);
      });

      getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'NBR_COTISATIONS').then((res) => {
        setNbrCotisantByFormatAccumulateCompare(res.value.data.data);
        setNbrCotisantByFormatAccumulateCompareFetch(false);
      });

      getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'CA').then((res) => {
        setCaCotisantByFormatAccumulateCompare(res.value.data.data);
        setCaCotisantByFormatAccumulateCompareFetch(false);
      });
    }
  }, [selectedFrequency]);

  // componentDidUpdate — selectedMonth
  useEffect(() => {
    if (prevSelectedMonthRef.current === selectedMonth) return;
    prevSelectedMonthRef.current = selectedMonth;

    if (selectedFrequency === "DAILY") {
      const initialShowCompareAppTypeStatsArray = [];
      initialShowCompareAppTypeStatsArray['Statutaire'] = false;
      initialShowCompareAppTypeStatsArray['Fiduciaire'] = false;
      setNbrCotisantByFormatFetch(true);
      setCaCotisantByFormatFetch(true);
      setFetchingMembershipAssociative(true);
      setShowCompareStats(false);
      setNbrCotisantByFormatAccumulateFetch(true);
      setCaCotisantByFormatAccumulateFetch(true);
      setShowCompareAppTypeStats(false);
      setCompareAll(false);
      setVisibleKeys(['Statutaire', 'Fiduciaire']);
      setShowCompareAppTypeStatsArray(initialShowCompareAppTypeStatsArray);
      const [year, month] = selectedMonth.split("-");



      getNbrCotisantByFormat([period], "DAILY", selectedMonth).then((res) => {
        setNbrCotisantByFormat(res.value.data.data);
        getNbrCotisantByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
          setNbrCotisantByFormatPrevYear(res.value.data.data);
          setNbrCotisantByFormatFetch(false);
        });
        getCAByFormat([period], "DAILY", selectedMonth).then((res) => {
          setCaCotisantByFormat(res.value.data.data);
          getCAByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
            setCaCotisantByFormatPrevYear(res.value.data.data);
            setCaCotisantByFormatFetch(false);
          });
        });
      });

      getMembershipAssociative([period], "DAILY", selectedMonth).then((res) => {
        setAssociativeMembership(res.value.data.data.sum);
        setFetchingMembershipAssociative(false);
      });

      getAccumulateStats([period], selectedFrequency, selectedMonth, 'NBR_COTISATIONS').then((res) => {
        setNbrCotisantByFormatAccumulate(res.value.data.data);
        setNbrCotisantByFormatAccumulateFetch(false);
      });

      getAccumulateStats([period], selectedFrequency, selectedMonth, 'CA').then((res) => {
        setCaCotisantByFormatAccumulate(res.value.data.data);
        setCaCotisantByFormatAccumulateFetch(false);
      });

      getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'NBR_COTISATIONS').then((res) => {
        setNbrCotisantByFormatAccumulateCompare(res.value.data.data);
        setNbrCotisantByFormatAccumulateCompareFetch(false);
      });

      getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'CA').then((res) => {
        setCaCotisantByFormatAccumulateCompare(res.value.data.data);
        setCaCotisantByFormatAccumulateCompareFetch(false);
      });
    }
  }, [selectedMonth]);

  // componentDidUpdate — showCompareStats
  useEffect(() => {
    if (prevShowCompareStatsRef.current === showCompareStats) return;
    prevShowCompareStatsRef.current = showCompareStats;

    setNbrCotisantByFormatCompareFetch(true);
    setCaCotisantByFormatCompareFetch(true);
    setMembershipAssociativeComapreFetch(true);
    setVisibleKeys(['Statutaire', 'Fiduciaire']);
    if (selectedFrequency == 'MONTHLY' && showCompareStats == true) {
      getNbrCotisantByFormat([period - 1], "MONTHLY").then((res) => {
        setNbrCotisantByFormatCompare(res.value.data.data);
        setNbrCotisantByFormatCompareFetch(false);
      });

      getMembershipAssociative([period - 1], "MONTHLY").then((res) => {
        setMembershipAssociativeComapre(res.value.data.data.sum);
        setMembershipAssociativeComapreFetch(false);
        getCAByFormat([period - 1], "MONTHLY").then((res) => {
          setCaCotisantByFormatCompare(res.value.data.data);
          setCaCotisantByFormatCompareFetch(false);
        });
      });
    } else if (selectedFrequency == 'DAILY' && showCompareStats == true) {
      const [year, month] = selectedMonth.split("-");
      getNbrCotisantByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
        setNbrCotisantByFormatCompare(res.value.data.data);
        setNbrCotisantByFormatCompareFetch(false);
      });
      getCAByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
        setCaCotisantByFormatCompare(res.value.data.data);
        setCaCotisantByFormatCompareFetch(false);
      });



      getMembershipAssociative([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
        setMembershipAssociativeComapre(res.value.data.data.sum);
        setMembershipAssociativeComapreFetch(false);
      });

      getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'NBR_COTISATIONS').then((res) => {
        setNbrCotisantByFormatAccumulateCompare(res.value.data.data);
        setNbrCotisantByFormatAccumulateCompareFetch(false);
      });

      getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'CA').then((res) => {
        setCaCotisantByFormatAccumulateCompare(res.value.data.data);
        setCaCotisantByFormatAccumulateCompareFetch(false);
      });
    }
  }, [showCompareStats]);

  const handleChangePeriod = (period) => {
    setPeriod(period);
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleTabTypeCotisationChange = (tab) => {
    setActiveTabTypeCotisation(tab);
  };

  const handleFrequencyChange = (period) => {
    setSelectedFrequency(period);
    setShowCompareStats(false);
  };

  const handleShowCompareStats = (show) => {
    setShowCompareStats(show);
  }

  const handleChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleSelectChange = (value) => {
    setSelectedMonth(value.value);
  };

  const handleChangeCheckbox = (event) => {
    setShowAccumulateStats(event.target.checked);
  };

  const handleToggleKey = (key) => {
    setVisibleKeys(prev =>
      prev.includes(key)
        ? prev.filter(k => k !== key)
        : [...prev, key]
    );
  };

  const showCompareStatsForAppType = (lineName) => {
    if (lineName === lineNameForStats) {
      const updatedShowCompareAppTypeStatsArray = Object.keys(showCompareAppTypeStatsArray).reduce(
        (acc, key) => {
          acc[key] = false;
          return acc;
        },
        {}
      );
      setShowCompareAppTypeStats(false);
      setLineNameForStats('');
      setShowCompareAppTypeStatsArray(updatedShowCompareAppTypeStatsArray);
      setVisibleKeys(['Statutaire', 'Fiduciaire']); // ← à rajouter

      return;
    };

    const updatedShowCompareAppTypeStatsArray = Object.keys(showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = key === lineName;
        return acc;
      },
      {}
    );
    setShowCompareAppTypeStats(true);
    setLineNameForStats(lineName);
    setShowCompareAppTypeStatsArray(updatedShowCompareAppTypeStatsArray);
    setCompareAll(false);
    setVisibleKeys([lineName]);
  };

  const showCompareStatsForAllAppType = (compareAll) => {
    const updatedShowCompareAppTypeStatsArray = Object.keys(showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = false;
        return acc;
      },
      {}
    );
    setShowCompareAppTypeStats(!compareAll);
    setLineNameForStats('');
    setShowCompareAppTypeStatsArray(updatedShowCompareAppTypeStatsArray);
    setCompareAll(!compareAll);
    setVisibleKeys(['Statutaire', 'Fiduciaire']);
  };

  const filterDataByLineName = (data, lineNameForStats) => {
    return Object.fromEntries(
      Object.entries(data).map(([date, values]) => {
        if (lineNameForStats === 'Statutaire') {
          return [date, Object.fromEntries(
            Object.entries(values).filter(([key]) => ['1', '2', '3', '4'].includes(key.toString()))
          )];
        } else if (lineNameForStats === 'Fiduciaire') {
          return [date, { 5: values[5] }];
        } else {
          return [date, values]; // fallback
        }
      })
    );
  };

  const handleStartMonthChange = (newstartMonth) => {
    localStorage.setItem('startMonthCotisationStats', newstartMonth);
    setStartMonth(prev => {
      if (newstartMonth > endMonth) {
        setEndMonth(newstartMonth);
      }

      return newstartMonth;
    });
  };

  const handleEndMonthChange = (newEndMonth) => {
    localStorage.setItem('endMonthCotisationStats', newEndMonth);
    setEndMonth(prev => {
      if (newEndMonth < startMonth) {
        setStartMonth(newEndMonth);
      }
      return newEndMonth;
    });
  };


  const yearsOptions = [
    { value: (moment().format('YYYY')), label: (moment().format('YYYY')) },
    { value: (moment().format('YYYY') - 1), label: (moment().format('YYYY')) - 1 },
  ];
  const formattedData = formatCotisantData(nbrCotisantByFormat, `${period - 1}-10`, `${period}-12`, selectedFrequency);
  const formattedCAData = formatCotisantData(caCotisantByFormat, `${period - 1}-10`, `${period}-12`, selectedFrequency);
  const formattedDataCompareThisYear = formatCotisantData(nbrCotisantByFormat, startMonth, endMonth, selectedFrequency);
  const formattedCADataCompareThisYear = formatCotisantData(caCotisantByFormat, startMonth, endMonth, selectedFrequency);
  const formattedDataCompare = formatCotisantData(nbrCotisantByFormatCompare, `${startMonth.split("-")[0] - 1}-${startMonth.split("-")[1]}`, `${endMonth.split("-")[0] - 1}-${endMonth.split("-")[1]}`, selectedFrequency);
  const formattedCADataCompare = formatCotisantData(caCotisantByFormatCompare, `${startMonth.split("-")[0] - 1}-${startMonth.split("-")[1]}`, `${endMonth.split("-")[0] - 1}-${endMonth.split("-")[1]}`, selectedFrequency);


  const monthsForDailyForSelect = Object.values(monthsForDaily).map(date => {
    const [year, month] = date.split("-");
    return { label: `${month}/${year}`, value: date };
  });

  const monthsForDailyForSelectDefault = monthsForDailyForSelect.find(month => month.value === selectedMonth) || monthsForDailyForSelect[0];


  const nbrCotisantByFormatByLinename = lineNameForStats ? filterDataByLineName(nbrCotisantByFormat, lineNameForStats) : nbrCotisantByFormat;
  const caCotisantByFormatCAByLinename = lineNameForStats ? filterDataByLineName(caCotisantByFormat, lineNameForStats) : caCotisantByFormat;

  const nbrCotisantByFormatByLinenamePrevYear = lineNameForStats ? filterDataByLineName(nbrCotisantByFormatPrevYear, lineNameForStats) : nbrCotisantByFormatPrevYear;
  const caCotisantByFormatCAByLinenamePrevYear = lineNameForStats ? filterDataByLineName(caCotisantByFormatPrevYear, lineNameForStats) : caCotisantByFormatPrevYear;

  const totalAccumulate = topFiveCityPercentageData.reduce(
    (acc, curr) => {
      acc.nbrInscription += curr.nbrInscription;
      acc.ca += curr.ca;
      return acc;
    },
    { nbrInscription: 0, ca: 0 }
  );
  const nbrInscrit = typeCotisants.nbrInscrit || {};
  const ca = typeCotisants.ca || {};

  const nbrInscritTotal = nbrInscrit.total ? nbrInscrit.total : 0;
  const caTotal = ca.total ? ca.total : 0;

  return (
    <div style={{ backgroundColor: '#F4F7F9' }}>
      <PageHeader header={_('STATISTIQUE COTISATIONS')} subHeader={_('EN QUELQUES CHIFFRES')} icon="STATISTICS_HEADER" periodFilter={'true'}>
        <div className={'flex items-center'}>
          <PeriodFilterCotisation period={period} onChangePeriod={handleChangePeriod} />
        </div>
      </PageHeader>
      <div className="contribution-stats">
        <div className="contribution-stats-container" style={{ width: '80%' }}>
          {
            typeCotisantsFetch
              ?
              <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
              :
              <React.Fragment>
                <div className='flex justify-between'>
                  <div className='flex justify-between' style={{ width: '40%', flexDirection: 'column' }}>
                    <BelgiumCityMap cityPercentageData={cityPercentageData} firstVariant={firstVariant} secondVariant={secondVariant} thirdVariant={thirdVariant} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div
                        onClick={() => {
                          setFirstVariant(firstVariant - 10);
                          setSecondVariant(secondVariant - 10);
                          setThirdVariant(thirdVariant - 10);

                        }}
                        style={{
                          cursor: 'pointer',
                          color: '#000',
                          textAlign: 'end',
                          cursor: 'pointer',
                          backgroundColor: '#F1F2F4',
                          borderRadius: '50%',
                          height: '26px',
                          width: '26px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >-</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '10px', height: '10px', backgroundColor: '#2d74d0' }} />
                        <span style={{ color: '#000' }}>{`> ${firstVariant}`}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '10px', height: '10px', backgroundColor: '#4582e4' }} />
                        <span style={{ color: '#000' }}>{`> ${secondVariant}`}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '10px', height: '10px', backgroundColor: '#88b0ed' }} />
                        <span style={{ color: '#000' }}>{`> ${thirdVariant}`}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ width: '10px', height: '10px', backgroundColor: '#dddddd' }} />
                        <span style={{ color: '#000' }}>{`< ${thirdVariant}`}</span>
                      </div>
                      <div
                        onClick={() => {
                          setFirstVariant(firstVariant + 10);
                          setSecondVariant(secondVariant + 10);
                          setThirdVariant(thirdVariant + 10);
                        }}
                        style={{
                          cursor: 'pointer',
                          color: '#000',
                          textAlign: 'end',
                          cursor: 'pointer',
                          backgroundColor: '#F1F2F4',
                          borderRadius: '50%',
                          height: '26px',
                          width: '26px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >+</div>
                    </div>
                  </div>
                  <div className='flex' style={{ width: '60%', marginLeft: '20px', flexDirection: 'column', gap: '20px' }}>
                    <h3 className='contribution-stats-title'>Top régions</h3>
                    <div style={topFiveCityPercentageData.length > 0 ? { color: '#29394D' } : { color: '#29394D', width: '100%', height: '60%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {topFiveCityPercentageData.length > 0
                        ?
                        <div>
                          {
                            topFiveCityPercentageData.map((item, index) => (
                              <React.Fragment key={index}>
                                <Row
                                  key={index}
                                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px' }}
                                >
                                  <Col span={19}>{item.region}</Col>
                                  <Col span={2} style={{ borderRight: '1px solid #E1E4E8' }}>{item.nbrInscription}</Col>
                                  <Col span={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>{item.ca / 100} €</Col>
                                </Row>
                                <div style={{ width: '100%', height: '2px', backgroundColor: '#B2BCC6' }}>
                                  <div style={{ width: `${Math.round((item.ca / topFiveCityPercentageData[0].ca) * 100)}%`, height: '2px', backgroundColor: '#18A0FB' }} />
                                </div>
                              </React.Fragment>
                            ))
                          }

                          <Row
                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px' }}
                          >
                            <Col span={19}>{"Autres"}</Col>
                            <Col span={2} style={{ borderRight: '1px solid #E1E4E8' }}>{nbrInscritTotal - totalAccumulate.nbrInscription}</Col>
                            <Col span={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>{(caTotal - totalAccumulate.ca) / 100} €</Col>
                          </Row>

                        </div>
                        :
                        <div>
                          <p style={{ textAlign: 'center', color: '#999' }}>{_('Aucune donnée disponible')}</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </React.Fragment>
          }
        </div>
        <div className="contribution-stats-container" style={{ width: '20%' }}>
          {
            nbrInscriptionFetch || typeCotisantsFetch
              ?
              <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
              :
              <div className='flex' style={{ flexDirection: 'column', gap: '20px' }}>
                <h3 className='contribution-stats-title'>{t('Type cotisations')}</h3>
                <CotisationFilterTypeCotisation
                  activeTabTypeCotisation={activeTabTypeCotisation}
                  onTabTypeCotisationChange={handleTabTypeCotisationChange}
                />
                <ContributionChart typeCotisants={typeCotisants} activeTabTypeCotisation={activeTabTypeCotisation} associativeMembership={formattedData.categories} />
              </div>
          }
        </div>
      </div>
      <div style={{ margin: '0 80px', marginTop: '40px', border: '1px solid #F1F2F4', background: '#FFF', paddingBottom: '20px' }}>
        <div className="contribution-stats-nbr-chart">
          <CotisantStats
            totalCotisations={formattedData.totalCotisations}
            categories={formattedData.categories}
            fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch || caCotisantByFormatFetch}
            formattedCAData={formattedCAData}
            frequency={selectedFrequency}
            year={[period]}
            month={selectedMonth}
            associativeMembership={associativeMembership}
            fetchingMembershipAssociative={fetchingMembershipAssociative}
            visibleKeys={visibleKeys}
            onToggleKey={handleToggleKey}
            showCompareStatsForAppType={showCompareStatsForAppType}
            showCompareAppTypeStatsArray={showCompareAppTypeStatsArray}
            showCompareStatsForAllAppType={showCompareStatsForAllAppType}
            compareAll={compareAll}
            showCompareAppTypeStats={showCompareAppTypeStats}
            showCompareStats={showCompareStats}
          />
          <div style={{ padding: '0 30px', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', gap: 20, width: '60%' }}>
            <div>
              <div style={{ display: "flex", justifyContent: selectedFrequency === "DAILY" ? "space-between" : "flex-end", alignItems: "center", width: "100%" }}>
                {
                  selectedFrequency === "DAILY" &&
                  <div>
                    {/* <select
                        className={'event-registrant-line-chart-month-picker'}
                        value={this.state.selectedMonth}
                        onChange={this.handleChange}
                      >
                        {monthsForDailyForSelect.map((month) => (
                          <option key={month.value} value={month.value}>
                            {month.label}
                          </option>
                        ))}
                      </select> */}
                    <ReactSelect
                      onChange={handleSelectChange}
                      styles={newSeasonFilterStyle()}
                      defaultValue={monthsForDailyForSelectDefault}
                      options={monthsForDailyForSelect}
                      components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
                    />
                  </div>
                }
                {
                  selectedFrequency === "DAILY" &&
                  <div>
                    <Checkbox checked={showAccumulateStats} onChange={handleChangeCheckbox}>Cumulative</Checkbox>
                  </div>
                }
                {
                  <div style={{ display: "flex", background: "#F0F0F0", borderRadius: 20, padding: 4 }}>
                    {["DAILY", "MONTHLY", "YEARLY"].map((period) => (
                      <button
                        key={period}
                        onClick={() => handleFrequencyChange(period)}
                        style={{
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: 20,
                          cursor: "pointer",
                          background: selectedFrequency === period ? "#6D7F92" : "transparent",
                          color: selectedFrequency === period ? "white" : "#555",
                          fontWeight: selectedFrequency === period ? "bold" : "normal",
                          width: "120px",
                          height: "32px",
                        }}
                      >
                        {t(period)}
                      </button>
                    ))}
                  </div>
                }
              </div>
            </div>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                <div style={{ display: "flex", gap: 30, width: "100%" }}>
                  <span
                    style={{
                      cursor: "pointer",
                      fontWeight: activeTab === "cotisation" ? "bold" : "normal",
                      borderBottom: activeTab === "cotisation" ? "3px solid #29394D" : "3px solid #ccc",
                      color: activeTab === "cotisation" ? "#29394D" : "#555",
                      paddingBottom: 5,
                      width: '100%',
                      textAlign: "center",
                    }}
                    onClick={() => handleTabChange("cotisation")}
                  >
                    {t('Cotisation')}
                  </span>
                  <span
                    style={{
                      cursor: "pointer",
                      fontWeight: activeTab === "chiffreAffaire" ? "bold" : "normal",
                      borderBottom: activeTab === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
                      color: activeTab === "chiffreAffaire" ? "#29394D" : "#555",
                      paddingBottom: 5,
                      width: '100%',
                      textAlign: "center",
                    }}
                    onClick={() => handleTabChange("chiffreAffaire")}
                  >
                    {t('CA')}
                  </span>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }}>
              {
                showCompareAppTypeStats
                  ?
                  <CotisantStatsChartLineCompare
                    data1={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulate : caCotisantByFormatCAByLinename) : (showAccumulateStats ? nbrCotisantByFormatAccumulate : nbrCotisantByFormatByLinename)}
                    data2={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulateCompare : caCotisantByFormatCAByLinenamePrevYear) : (showAccumulateStats ? nbrCotisantByFormatAccumulateCompare : nbrCotisantByFormatByLinenamePrevYear)}
                    activeTab={activeTab}
                    year={[period]}
                    frequency={selectedFrequency}
                    fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
                    nbrCotisantByFormatCompareFetch={false}
                    showAccumulateStats={showAccumulateStats}
                    visibleKeys={visibleKeys}
                  />
                  :
                  <CotisantStatsChartLine
                    data={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulate : caCotisantByFormat) : (showAccumulateStats ? nbrCotisantByFormatAccumulate : nbrCotisantByFormat)}
                    activeTab={activeTab}
                    year={[period]}
                    frequency={selectedFrequency}
                    fetching={nbrCotisantByFormatFetch || nbrCotisantByFormatAccumulateFetch || caCotisantByFormatFetch}
                    selectedMonth={selectedMonth}
                    showAccumulateStats={showAccumulateStats}
                    visibleKeys={visibleKeys}
                  />
              }
            </div>
          </div>
        </div>
        {showCompareStats && period > 2024 && (selectedFrequency == 'MONTHLY' || selectedFrequency == 'DAILY') && nbrCotisantByFormatFetch == false && (
          <div style={{ marginTop: '30px', padding: '0 30px', display: 'flex', justifyContent: 'space-between', gap: 20, width: '100%' }}>
            <div style={{ width: '50%' }}>
              <CotisantStatsCompare
                totalCotisations={formattedDataCompareThisYear.totalCotisations}
                categories={formattedDataCompareThisYear.categories}
                fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
                fetchingCACotisantByFormat={caCotisantByFormatFetch}
                currentYear={period}
                formattedDataCompare={formattedDataCompare}
                nbrCotisantByFormatCompareFetch={nbrCotisantByFormatCompareFetch}
                formattedCADataCurrentYear={formattedCADataCompareThisYear}
                formattedCADataPrevYear={formattedCADataCompare}
                caCotisantByFormatCompareFetch={caCotisantByFormatCompareFetch}
                associativeMembership={associativeMembership}
                fetchingMembershipAssociative={fetchingMembershipAssociative}
                membershipAssociativeComapre={membershipAssociativeComapre}
                membershipAssociativeComapreFetch={membershipAssociativeComapreFetch}
                frequency={selectedFrequency}
                month={selectedMonth}
                visibleKeys={visibleKeys}
                onToggleKey={handleToggleKey}
              />
            </div>
            <div style={{ width: '50%', padding: '0 30px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
                {/* {
                    selectedFrequency === "DAILY" &&
                    <div>
                      <Checkbox checked={showAccumulateStats} onChange={handleChangeCheckbox}>Voir la courbe cumulative</Checkbox>
                    </div>
                  } */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                  <div style={{ display: "flex", gap: 30, width: "100%" }}>
                    <span
                      style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "cotisation" ? "bold" : "normal",
                        borderBottom: activeTab === "cotisation" ? "3px solid #29394D" : "3px solid #ccc",
                        color: activeTab === "cotisation" ? "#29394D" : "#555",
                        paddingBottom: 5,
                        width: '100%',
                        textAlign: "center",
                      }}
                      onClick={() => handleTabChange("cotisation")}
                    >
                      Cotisation
                    </span>
                    <span
                      style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "chiffreAffaire" ? "bold" : "normal",
                        borderBottom: activeTab === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
                        color: activeTab === "chiffreAffaire" ? "#29394D" : "#555",
                        paddingBottom: 5,
                        width: '100%',
                        textAlign: "center",
                      }}
                      onClick={() => handleTabChange("chiffreAffaire")}
                    >
                      Chiffre d'affaire
                    </span>
                  </div>
                </div>
              </div>
              {
                selectedFrequency === 'MONTHLY' &&
                <MonthFilterContribution
                  startMonth={startMonth}
                  endMonth={endMonth}
                  year={period}
                  handleStartMonthChange={handleStartMonthChange}
                  handleEndMonthChange={handleEndMonthChange}
                />
              }
              <CotisantStatsChartLineCompare
                data1={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulate : caCotisantByFormat) : (showAccumulateStats ? nbrCotisantByFormatAccumulate : nbrCotisantByFormat)}
                data2={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulateCompare : caCotisantByFormatCompare) : (showAccumulateStats ? nbrCotisantByFormatAccumulateCompare : nbrCotisantByFormatCompare)}
                activeTab={activeTab}
                year={[period]}
                frequency={selectedFrequency}
                fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
                nbrCotisantByFormatCompareFetch={nbrCotisantByFormatCompareFetch}
                showAccumulateStats={showAccumulateStats}
                visibleKeys={visibleKeys}
                startMonth={startMonth}
                endMonth={endMonth}
              />
            </div>
          </div>
        )}
        {
          (selectedFrequency === "MONTHLY" || selectedFrequency == 'DAILY') && period > 2024 && showCompareAppTypeStats === false &&
          <div className={"flex flex-col items-center mt-3"}>
            <span className={"event-cycle-trainings"}
              onClick={() => handleShowCompareStats(!showCompareStats)}>{showCompareStats ? _("REDUCE") : _("COMPARE_WITH_ANOTHER_YEAR")}</span>
            <div className={"event-cycle-chevron"}
              onClick={() => handleShowCompareStats(!showCompareStats)}>
              <img src="/img/icons/chevron-down.svg"
                className={showCompareStats && "cycle-stats-chevron-rotate"} />
            </div>
          </div>
        }
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  lng: state.params.lng,
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setCurrentNavPage,
  getNbrCotisants,
  getTypeFormats,
  getNbrCotisantByFormat,
  getCAByFormat,
  getCotisationMonths,
  getMembershipAssociative,
  getAccumulateStats,
  deleteCacheForCotisationStats,
  getCacheOldestEntryPeriodForCotisationStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContributionStatisticsPage);



// WEBPACK FOOTER //
// ./app/pages/Admin/ContributionStatisticsPage.js